export default "__VITE_ASSET__364b96fd__"